import { post } from '~/plugins/nikan-api'
import _ from 'lodash'
import Endpoints from '@nikan/endpoints'

const UNCHANGED = 'unchanged'

const Keys = {
  ADD_WAREHOUSES: 'add_warehouses',
  SET_ALL_AS_UNCHANGED: 'set_all_as_unchanged',
  CLEAR: 'clear'
}

export const state = {
  warehouses: []
}
export const mutations = {
  [Keys.ADD_WAREHOUSES](state, warehouses) {
    if (!warehouses || !warehouses.length) {
      return
    }

    state.warehouses = warehouses
  },

  [Keys.SET_ALL_AS_UNCHANGED](state) {
    for (warehouse in state.warehouse) {
      warehouse.rowState = UNCHANGED
    }
  },

  [Keys.CLEAR](state) {
    state.warehouses = []
  }
}
export const actions = {
  async refresh({ dispatch, commit, state }, options) {
    options = _.extend({ force: false }, options)

    // clear
    commit(Keys.CLEAR)

    var key = 'data-warehouses'

    if (options.force !== true) {
      var cached = await dispatch('cache/get', key, { root: true })
      if (cached != null) {
        commit(Keys.ADD_WAREHOUSES, cached)
        return
      }
    }

    var result = await post(Endpoints.getUrl('sale.warehouse.list'))
    if (result.success) {
      var cacheObj = {
        key,
        seconds: 24 * 60 * 60,
        value: result.data.items
      }

      dispatch('cache/set', cacheObj, { root: true })
      commit(Keys.ADD_WAREHOUSES, cacheObj.value)
    }
  },

  async modify({ dispatch, commit, state }, warehouses) {
    warehouses = warehouses.filter(x => x.rowState !== UNCHANGED)
    commit(Keys.ADD_WAREHOUSES, warehouses)

    let updateds = state.warehouses.filter(x => x.rowState !== UNCHANGED)
    let result = await post(Endpoints.getUrl('sale.warehouse.modify'), { items: updateds })
    if (result.success) {
      commit(Keys.SET_ALL_AS_UNCHANGED)
      dispatch('socket/broadcastRefresh', 'Warehouses', { root: true })
    }
  },

  clear({ commit }) {
    commit(Keys.CLEAR)
  }
}
export const getters = {
  all: state => {
    return state.warehouses
  },
  getById: state => id => {
    return _.head(state.warehouses.filter(x => x.id === id))
  },
  derties: state => {
    return state.warehouses.filter(item => item.rowState !== UNCHANGED)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
